import React, { useState } from "react";
import { PortfolioElementType } from "types/PortfolioTypes";
import styles from "./portfolioCompareTableDelta.module.scss";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import PortfolioTableCompare from "./PortfolioTableCompare";
import PortfolioDelta from "./PortfolioDelta";
import colorsStore from "shared/store/colorsStore";
// import FinecoTable from "./components/FinecoTable";
type Props = {
  dataItem: PortfolioElementType;
  dataItem2: PortfolioElementType;
  titleDelta: string;
  subSection?: boolean;
  hideTotal?: boolean;
};
const PortfolioCompareTableDelta: React.FC<Props> = ({
  dataItem,
  dataItem2,
  subSection,
  titleDelta,
  hideTotal = false,
}) => {
  const [tableHeight, setTableHeight] = useState(0);
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);

  // Calculate position for the horizontal section line
  const sectionLineIndex = dataItem.data.findIndex((item) => item.label === "BBB");
  const headerHeight = 80;
  const rowHeight = 41;
  const sectionLinePosition = sectionLineIndex >= 0
    ? headerHeight + (sectionLineIndex + 1) * rowHeight
    : 0;
  return (
    <>
      {!subSection && (
        <h3 className={commonStyles.titleChart}>{dataItem.configData.label}</h3>
      )}
      {subSection && (
        <div className={commonStyles.subtitleChart}>
          {dataItem.configData.label}
        </div>
      )}
      <div
        className={[
          styles.portfolioDistribution,
          styles.twoChartSideBySide,
          "printRow",
        ].join(" ")}
      >
        {/* Horizontal section line spanning both table and chart */}
        {sectionLineIndex >= 0 && (
          <div
            className={styles.sectionLine}
            style={{
              top: `${sectionLinePosition}px`,
              background: `repeating-linear-gradient(to right, ${colorsConfig.Gray3 || '#C4C7CC'} 0px, ${colorsConfig.Gray3 || '#C4C7CC'} 5px, transparent 5px, transparent 10px)`,
            }}
          />
        )}
        <PortfolioTableCompare
          dataItem={dataItem}
          dataItem2={dataItem2}
          hideTotal={hideTotal}
          onResize={setTableHeight}
          section_label="Investment grade"
          section_line_after="BBB"
        />
        <PortfolioDelta
          title={titleDelta}
          dataItem={dataItem}
          dataItem2={dataItem2}
          tableHeight={tableHeight}
        />
      </div>
    </>
  );
};

export default PortfolioCompareTableDelta;
